export default __webpack_public_path__ + "static/media/Kanipakam-slider-01@2x.18d3cba6.png";